<template>
  <header>
    <a-form class="form" layout="vertical" ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="Empresa" name="entity" required>
        <entity-picker :showAll="false" defaultBehavior v-model:value="formState.entity" />
      </a-form-item>

      <PlanSeparatedDatePicker
        v-model:startDate="formState.startDate"
        v-model:endDate="formState.endDate"
        startPlaceholder="-- / -- / ----"
        endPlaceholder="-- / -- / ----"
      />
    </a-form>

    <div class="actions">
      <span v-if="totalRecords !== null" class="total">{{ totalRecords }} registros</span>

      <a-button type="primary" :disabled="isButtonDisabled || loadingSearch" :loading="loadingSearch" @click="handleSearch">
        Buscar
        <SearchOutlined />
      </a-button>
    </div>
  </header>

  <a-table
    size="middle"
    id="inbound-table"
    :scroll="scrollStyle"
    :columns="leadsResumeColumns"
    :data-source="reportData?.results"
    :loading="isTableLoading"
    :pagination="pagination"
    @change="handleTableChange"
  >
  </a-table>
</template>

<script setup>
import { computed, reactive, ref } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";

import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
import { leadsResumeColumns } from "@/app/reports/utils/tableColumns/leadsResume";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import { sequenceReportService } from "@/app/reports/services/sequenceReport.service";
import PlanSeparatedDatePicker from "@/app/shared/components/pickers/PlanSeparatedDatePicker.vue";

const { scrollStyle } = useScrollResize();

// Form
const formState = reactive({
  entity: null,
  startDate: null,
  endDate: null,
});
const totalRecords = ref(null);
const isButtonDisabled = computed(() => {
  for (const key in formState) {
    if (formState[key] === null || formState[key] === undefined) return true;
  }

  return false;
});

// Table
const reportData = ref(null);
const currentTablePage = ref(1);
const isTableLoading = ref(false);
const loadingSearch = ref(false);

const pagination = computed(() => ({
  total: reportData.value?.count,
  current: currentTablePage.value,
  pageSize: TABLE_PAGE_SIZE,
  showSizeChanger: false,
}));

const handleTableChange = async (page) => {
  currentTablePage.value = page.current;
  await fetchReportData();
};

const fetchReportData = async () => {
  isTableLoading.value = true;

  reportData.value = await sequenceReportService.getLeadsResume(formState, currentTablePage.value);

  isTableLoading.value = false;
};

const handleSearch = async () => {
  if (loadingSearch.value) return;

  try {
    loadingSearch.value = true;
    currentTablePage.value = 1;
    await fetchReportData();
  } catch (error) {
    console.log("Error handleSearch LeadsResume", error);
  } finally {
    loadingSearch.value = false;
  }
};
</script>

<style lang="sass" scoped>
header
  display: flex
  justify-content: space-between
  align-items: flex-end
  margin: 15px 0

.form
  display: flex
  gap: 10px

.ant-form-item
  margin: 0
  width: 180px

:deep(.ant-form-item-label)
  padding: 0

.actions
  display: flex
  align-items: center
  gap: 10px

.date-picker
  width: 100%

#inbound-table tfoot th,
#inbound-table tfoot td
  background-color: #fafafa !important
</style>
